export enum AlertWay {
  ABOVE = 'ABOVE',
  BELOW = 'BELOW',
}
